import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

// 设置rem基准值函数
function setRem () {
  // 假设设计稿宽度为1536px
  const baseWidth = 1536
  // 当前窗口的宽度
  const windowWidth = document.documentElement.clientWidth || document.body.clientWidth
  // console.log(windowWidth)
  // 计算rem的大小
  const rem = windowWidth * 100 / baseWidth
  // 设置页面中的根字体大小
  document.documentElement.style.fontSize = `${rem}px`
  // console.log(rem)
}

// 初始化设置rem
setRem()

// 监听窗口大小变化
window.onresize = function () {
  setRem()
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
